import { useState } from "react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const useFunctions = () => {
  const [phone, setPhone] = useState("");

  const service_id = process.env.REACT_APP_SERVICE_ID;
const template_id = process.env.REACT_APP_TEMPLATE_ID;
const public_key = process.env.REACT_APP_PUBLIC_KEY;


  

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    website: "",
    budget:"",
    service_data:"",
    service_software:"",
    service_ads:"",
    service_digital:"",
    service_website:"",
    service_graphics:"",
    service_support:"",
    service_ebay:"",
    message:"",
})


const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};


const sendEmail = async (e) => {
  e.preventDefault();

  const sendEmailData = {
    name: formData.name,
    email: formData.email,
    phone: phone,
    website: formData.website,
    budget: formData.budget,
    service_data: formData.service_data,
    service_software: formData.service_software,
    service_ads: formData.service_ads,
    service_digital: formData.service_digital,
    service_website: formData.service_website,
    service_graphics: formData.service_graphics,
    service_support: formData.service_support,
    service_ebay: formData.service_ebay,
    message: formData.message,
  }

  emailjs
    .send(
      service_id, // Replace with your EmailJS Service ID
      template_id, // Replace with your EmailJS Template ID
      sendEmailData, // Form Data Send EmailJS
      public_key // Replace with your EmailJS Public Key
    )
    .then(
      (result) => {
      
       if(result){
        toast.success("Submited Successful");
        // alert('Submited Successful!');
        handleRefresh();
       }

       
     
      },
      (error) => {
      if(error){
        toast.error("Submit Not Successful!");
        // alert('Submit Not Successful!');
        console.log(error.text);
      }
        
      }
    );
}

const handleRefresh = () => {

window.location.reload();
};


  // Scroll Section
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0, // Scroll to the top
      behavior: "smooth" // Smooth scrolling animation
    });
  };



  return {
    phone, 
    setPhone,
    scrollToSection,
    handleScrollToTop,
    handleChange,
    sendEmail,
  };
};

export default useFunctions;
